export const SET_LIST_NAVIGATION = "SET_LIST_NAVIGATION";
export const LOAD_ITEMS = "LOAD_ITEMS";
export const SET_CURRENT_INDEX = "SET_CURRENT_INDEX";
